// Per-dashboard catalog of pinnable widgets, mirroring
// app/services/dashboard_prefs_service.py on the backend exactly (widget
// ids and default set/order must stay in sync with that file). ADMIN and HR
// share one catalog on the backend too, so there's no need to key this by
// backend role -- each dashboard page just imports the constant it needs.

export type WidgetDefinition = {
  id: string;
  label: string;
};

export const ADMIN_HR_WIDGETS: WidgetDefinition[] = [
  { id: "inside-visitors", label: "Inside Visitors" },
  { id: "recent-visitors", label: "Recent Visitors" },
  { id: "queue-aging", label: "Queue Aging" },
  { id: "alert-snapshot", label: "Alert Snapshot" },
  { id: "operational-counters", label: "Operational Counters" },
];
export const ADMIN_HR_DEFAULT_WIDGETS: string[] = ["inside-visitors", "recent-visitors"];

export const GATE_WIDGETS: WidgetDefinition[] = [
  { id: "today-activity", label: "Today Activity" },
  { id: "recent-visitors", label: "Recent Visitors" },
];
export const GATE_DEFAULT_WIDGETS: string[] = ["today-activity", "recent-visitors"];

export const EMPLOYEE_WIDGETS: WidgetDefinition[] = [{ id: "recent-activity", label: "Recent Activity" }];
export const EMPLOYEE_DEFAULT_WIDGETS: string[] = ["recent-activity"];
